
import React, { CSSProperties, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { TextField } from '@mui/material';

export interface TimePickerProps {
    name: string;
    label: string;
    value: string;
    onChange(value: string): any;
    fullWidth?: boolean | undefined;
    required?: boolean | undefined;
    disabled?: boolean | undefined;
    error?: boolean | undefined;
    showMask?: boolean | undefined;
    style?: CSSProperties;
    helperText?: React.ReactNode;
    invalidFormatMessage?: React.ReactNode;
}

export default function TimePicker(props: TimePickerProps) {
    const { name, label, value, onChange, fullWidth, required, error, helperText, invalidFormatMessage, showMask, style, disabled } = props;

    const [invalidFormat, setInvalidFormat] = useState<boolean>(false);

    function handleChange(val: string) {
        if (val !== '' && /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val) === false && invalidFormat === false) {
            setInvalidFormat(true);
        } else if (invalidFormat) {
            setInvalidFormat(false);
        }
        onChange(val);
    }

    return (
        <MaskedInput
            mask={[/[0-2]/, /\d/, ':', /[0-5]/, /\d/,]}
            keepCharPositions={true}
            showMask={showMask}
            guide
            style={style}
            name={name}
            value={value}
            disabled={disabled}
            onChange={(e) => handleChange(e.target.value)}
            render={(ref, props) => (
                <TextField
                    inputRef={ref}
                    {...props}
                    label={label}
                    value={value}
                    margin="dense"
                    variant="outlined"
                    fullWidth={fullWidth}
                    required={required}
                    error={error || invalidFormat}
                    helperText={helperText || (invalidFormat ? invalidFormatMessage : undefined)}
                />
            )}
        />
    );
}